<template>
  <div>
    <div class="back-btn">
      <router-link
      :to="{ name: 'CreditProvider' }">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.828 7.00017H16V9.00017H3.828L9.192 14.3642L7.778 15.7782L0 8.00017L7.778 0.222168L9.192 1.63617L3.828 7.00017Z"
            fill="#1A2139"
          />
        </svg>
      </router-link>

      <h1>Loan Term Configuration</h1>
    </div>

    <div class="loan-term-configuration">
      <div class="header">
        <div>
          <h1>Loan Summary</h1>
          <p>
            Loan configuration involves setting the key parameters of a loan,
            such as the loan amount, interest rate, repayment term, and payment
            schedule.
          </p>
        </div>
      </div>
      <LoanConfigurationForm />
    </div>
  </div>
</template>
    
  <script>
import LoanConfigurationForm from "@/components/creditProvider/LoanConfigurationForm.vue";

export default {
  name: "Loan Configuration",
  components: {
    LoanConfigurationForm,
  },
  data() {
    return {};
  },
};
</script>
 
<style scoped>
.loan-term-configuration {
  padding: 30px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 50px;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1a2139;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.back-btn a {
  padding: 10px;
  border-radius: 100%;
  background-color: #d9dce8;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.header div {
  width: 60%;
}

@media (max-width: 600px) {
  .header div {
    width: 90%;
  }
}

.header div h1 {
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 10px;
  color: #2d303d;
}

.header div p {
  color: #8d9da8;
  width: 100%;
  font-weight: 100;
  font-size: 14px;
}
</style>